import * as React from 'react';
import axios from 'axios';
import LogPlusAnyResourcesAutocomplete from './LogPlusAnyResourcesAutocomplete';
import { AutocompleteMode, IRelatedDeviceListItem } from './IModels';
import LogPlusAutocompleteOption from './LogPlusAutocompleteOption';

export interface GetRelatedDevicesAutocompleteResourcesResult {
	success: boolean,
	status?: "LogDisabled",
	items?: IRelatedDeviceListItem[]
}

interface IProps<T> {
	value: T[],
	onSelect: (value: T[]) => void,
	kinds: string[],
	multiple?: true | false,
	placeholderText?: string,
	error?: boolean;
	helperText?: string,

	notifierId: string | null,
	searchIn: (keyof T)[],
	mode: AutocompleteMode,
	filterId: string,
}

export default function LogPlusRelatedDevicesAutocomplete(props: IProps<IRelatedDeviceListItem>)
{
	const getOptionSelected = (option: IRelatedDeviceListItem, value: IRelatedDeviceListItem) => {
		return option.HdKind === value.HdKind && option.AssetId === value.AssetId;
	}

	let notifierId: string = null
	if (props.mode === 'relatedNotifier') {
		notifierId = props.notifierId;
	}

	return (<LogPlusAnyResourcesAutocomplete
		{...props}
		getOptionLabel={(option: IRelatedDeviceListItem) => option.Name}
		getOptionSelected={getOptionSelected}
		cachePrefix={notifierId}
		createRequest={(text: string) => {
			return {
				text: text,
				notifierId: notifierId,
				filterId: props.filterId,
			}
		}}
		loadOptions={(request, callback) => {
			if (!request.notifierId && props.mode === 'relatedNotifier') {
				callback([]);
			}
			
			axios.get<GetRelatedDevicesAutocompleteResourcesResult>('/LogPlusResources/GetRelatedDevicesAutocomplete/', {
				params: {
					notifierId: request.notifierId,
					search: request.text,
					searchIn: props.searchIn?.join(','),
					max: 20,
					kinds: props.kinds.join(','),
				}
			})
				.then(r => {
					callback(r.data.items);
				});
		}}
		renderOption={option => <LogPlusAutocompleteOption
			kind={option.HdKind}
			name={option.Name}
			type={option.AssetKind}

			item={option}
			searchIn={props.searchIn}
		/>}
	/>);
}